import * as yup from 'yup';

export const numberFieldInitialValues = {
    label: 'Number Field',
    name: 'number-field',
    required: false,
};

export const numberFieldForm = [
    {
        id: '1',
        label: 'label',
        name: 'label',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '2',
        label: 'name',
        name: 'name',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '4',
        label: 'Required',
        name: 'required',
        component: 'FormikCheckbox',
    },
];

export const numberFieldValidation = {
    label: yup
        .string()
        .matches(/^[a-zA-Z0-9 ]*$/, 'Alphanumeric characters only')
        .required(),
    name: yup
        .string()
        .matches(
            /^([A-z0-9_-])*[^\s]\1*$/,
            'No spaces, only alphanumeric characters and hyphens are allowed'
        )
        .required(),
    placeholder: yup
        .string()
        .matches(/^[a-zA-Z0-9 ]*$/, 'Alphanumeric characters only'),
};
